import React, { Fragment } from 'react';

export default {
  duties: {
    counselor: {
      label: 'Counselor - Duties 輔導員職責',
      description() {
        return (<Fragment>
          <p>
            Attend 8-hr training for Counselors one week before camp date in El Monte. <br/>
            Date to be announced
          </p>
          <p>
            (A) During Meals: <br/>
            1. You must bring campers 15 minutes earlier to get cafeteria ready <br/>
            2. Direct and line up your campers to get their meal. <br/>
            3. Maintain a low noise level and proper manner of conduct. <br/>
            4. After meals, help and direct campers to clean tables and floors. <br/>
          </p>
          <p>
            (B) For Classes:  <br/>
            1. Bring campers to class 5 minutes early to the assigned area  <br/>
            2. Help instructor maintain order in the class.  <br/>
            3. Assist teacher in using teaching material.  <br/>
            4. Help campers to clean up classroom when class ends.  <br/>
          </p>
          <p>
            (C) During Outdoor and Indoor Activities: <br/>
            1. Be cautious of camper&#39;s state of health, report to guardian immediately or report to nurse if first aid needed. (in health cottage) <br/>
            2. Always be aware of safety precautions. <br/>
            3. Always make sure all campers stay together. <br/>
          </p>
          <p>
            (D) During Break Time: <br/>
            1. Campers may not go anywhere alone. <br/>
            2. Use time wisely for preparation of skit/play or team flag or team song. <br/>
            3. All campers must wake up and sleep at specified times. <br/>
            4. After specified sleep time, campers and counselor may not talk or wander about. <br/>
          </p>
          <p>
            (E) General Rules of Conduct: <br/>
            1. All activities must report to the guardian ahead of time. <br/>
            2. When Campers behave inappropriately, report to guardians immediately. <br/>
            3. Treat Campers with reason, firmness and strictness yet with amiability. <br/>
            4. If any emergency occurs, report to the Guardian or Nurse or Camp Director immediately. <br/>
            5. The purpose of a counselor is to help people and acquire leadership skills. <br/>
            6. Camper and/or Counselors are not allowed to be together alone in a room with a Non-teammate in the dorms at all times <br/>
          </p>
          <p>
            一、用餐時 <br/>
            1. 帶領全組同學按規定時間前15分鐘到達餐廳 <br/>
            2. 帶領及協助全組同學領取食物 <br/>
            3. 維持全組同學用餐時的秩序，不可大聲喧嘩 <br/>
            4. 用餐後指揮並協助全組同學清潔餐桌上、下及四周，桌椅歸回原位並將餐具放在回收處 <br/>
          </p>
          <p>
            二、上課時 <br/>
            1. 帶領全組同學於上課前五分鐘準時到達上課地點 <br/>
            2. 幫助同學了解課程內容，並維持上課秩序 <br/>
            3. 下課後應將教室桌、椅歸回原位 <br/>
          </p>
          <p>
            三、營外或室外活動時 <br/>
            1. 隨時瞭解每位同學身體狀況，如有哪位同學身體不適立即報告監護人或護士 <br/>
            2. 隨時注意同學之動向與安全，嚴禁接近危險地區 <br/>
            3. 營外活動時，一定要跟本組同學一起行動，注意安全 <br/>
          </p>
          <p>
            四、休閒時 <br/>
            1. 不可讓本組同學單獨活動，應全組一起行動 <br/>
            2. 利用時間編練晚會節目、製作隊旗隊歌 <br/>
            3. 確實掌握時間，不可遲到、遲睡或遲起，就寢後不可講話及走動 <br/>
            4. 晚間就寢時，絕不可再有個人私自活動的行為 <br/>
          </p>
          <p>
            五、一般原則 <br/>
            1. 全組活動要向監護人報告，如有同學不守規則應主動向監護人報告 <br/>
            2. 對同學之要求要合情合理，規定時語氣要堅定，要嚴格也要有獎勵 <br/>
            3. 隨時隨地跟同學一起，並與監護人分工合作 <br/>
            4. 如有緊急情況隨時報告監護人或營主任 <br/>
            5. 配合監護人帶領並輔導同學參加各項活動 <br/>
            6. 不得與非室友在房間內獨處 <br/>
          </p>
        </Fragment>)
      },
      key: 'duties.counselor.signature',
    },
    guardian: {
      label: 'Guardian - Duties',
      description() {
        return (<Fragment>
          <p>
            1) Look after your team campers at all times <br/>
            隨時關注學員
          </p>
          <p>
            2) Accompany and assist Counselor who will lead his/her team to various activities <br/>
            與輔導員密切合作並協助各項活動
          </p>
          <p>
            3) Communicate with Counselor of events <br/>
            各項活動均事先與輔導員溝通
          </p>
          <p>
            4) Contact Nurse if there are any medical issues with Campers <br/>
            如果學員有任何醫藥或健康的問題, 盡快與護士聯絡
          </p>
          <p>
            5) Sleep in dorm with Campers and Counselor <br/>
            睡覺時必須與輔導員和學員們住同一寢室
          </p>
          <p>
            6) Have students keep room clean at all times for inspection purpose <br/>
            保持寢室內的清潔,以備隨時內務檢查
          </p>
          <p>
            7) Take photographs of team activities and videos and submit to Reporter or Editor to upload to Facebook <br/>
            照些團隊活動的照片作為編輯營訓或上傳至臉書
          </p>
          <p>
            8) Assist Teachers in classrooms <br/>
            協助課堂老師
          </p>
          <p>
            9) No smoking any time during the summer camp <br/>
            在夏令營活動期間不能吸菸
          </p>
          <p>
            這是志願服務的工作，如果有人做得好，請大力稱讚，讓大家愉快地忙碌。<br/>
            這是不求報償的工作，如果有人做得不盡您意，也許他需要您的幫忙。<br/>
            如果有人做得有違常理，請向他本人賜教，如果是我們用人不當，請盡快向營主任反映。<br/>
            我們必須公平公正處理事務，學員中可能有您的孩子或朋友的孩子，甚勿偏袒或護短。<br/>
            學員的安全維護最重要；學員的生活愉快要維持，以正面積極的讚美代替苛責處罰。<br/>
          </p>
        </Fragment>)
      },
      key: 'duties.guardian.signature',
    },
  },
  rules: {
    reporter: {
      label: 'Reporter - Rules',
      description: counselorAndReporterRules,
      key: 'rules.reporter.signature',
    },
    counselor: {
      label: 'Counselor - Rules',
      description: counselorAndReporterRules,
      signatureLabel: 'E-Signature By typing my name below, I certify that I am over the Age of 18.  If I am under 18, then my Parent/Guardian will also type his/her name here as agreeing to all the terms, conditions, and rules.',
      key: 'rules.counselor.signature',
    }
  }
};

function counselorAndReporterRules() {
  return (
    <Fragment>
      <p>
        I attest that the information is true and accurate, and my parents/guardians have agreed to allow me to apply for this Counselor/Reporter position. If I am approved, I will attend an 8-hour leadership training and orientation.
      </p>
      <p>
        I agree to be respectful and act responsibly and in good faith to all campers, guardians, teachers and to abide by all rules to ensure a safe and pleasant week.
      </p>
      <p>
        I will not hold SCCCS or its officers, teachers, and helpers liable for the above activity and medical aid rendered. I understand this activity is voluntary and he/she has my permission to participate in it. I also understand that there are certain risks involved in these activities, including, but not limited to, accidents, injuries, illness or death while traveling to and from said activity, and/or in the course of these activities, and/or the potential for property damage and/or loss. I will reimburse SCCCS for medical or other expenses incurred for his/her care.
      </p>
      <p>
        茲聲明本表所填各項屬實，我身心健康，我的父母/監護人也同意我申請擔任貴會夏令營輔導員/小記者
        ，如獲聘任，將準時參加訓練9am-4pm(另安排日期)的營前講習及領導才能講習，按受訓其間表現決定
        錄取順序。活動期間將以認真負責、公平合理與親切和藹的態度照顧學員，並與貴會工作人員合作，遵
        守相關規定，讓學員有個快樂安全的夏令營
      </p>
    </Fragment>)
}
